module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAAAcUlEQVRIie2WsQmAMBBFn5qBXCZgZSHB0iJjWGQECxuFrGghV2SCwK/uLfA4Dh5/2FN6gAUd7whEodCIAcjACgSB8ANugcdxnE4sgyewCeNwtSJNwu9lkxb1pQKP4zidWAYP9UZqRVJmcLYJWoVCgPoDTIIS6XsVKiQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/menu.png
// module id = WgdI
// module chunks = 1